import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Database_naming extends PureComponent {
  render() {
    return (
      <div className="row" id="database_naming">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Field Naming Schema </h2>
              <p>
                ElasticSearch cannot handle changing object types for a defined
                field. We have solved this by adding a naming convention layer
                to the Nexoid API. The API checks to make sure the data type
                matches the field naming convention. If you try to add a new
                field not using the naming convention, the API makes a best
                guess based on the data provided by that first record.
              </p>
              <p>
                Field names are always lowercase. Spaces are not supported;
                letters, numbers and underscore are the only supported
                characters.
              </p>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Field Naming Schema Definitions </h2>
            </section>

            <section>
              <h3>Text / String</h3>
              <p>
                Text fields are limited to 32,000 characters. (Approximately
                4000 words).
              </p>
              <p>text:</p>
              <div className="darkCode">
                <div>
                  prefix: "<strong>text_</strong>"
                </div>
                <div>
                  <br />
                </div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Long / Numbers</h3>
              <p>
                Numbers are stored as long 64-bit integers with a minimum value
                of -2^63 and a maximum value of 2^63-1. Real numbers are
                converted to integers using the decimal function. A decimal
                value of 2 in the interface stores an integer of Math.floor(X *
                100), i.e. 12.3456 turns into 1234.
              </p>
              <p>long:</p>
              <div className="darkCode">
                <div>
                  prefix: "<strong>long_</strong>"
                </div>
                <div>
                  <br />
                </div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"long_movie_view_count"</span>:{" "}
                  <span className="jsonP">85196</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Dates / DateTime</h3>
              <p>
                Zulu or GMT +0 no daylight saving is used to store all DateTime
                values. The API imports and exports DateTime as a string or
                text. The DateTime field supports multiple formats, as seen in
                this example below.
              </p>
              <p>datetime:</p>
              <div className="darkCode">
                <div>
                  prefix: "<strong>date_</strong>"
                </div>
                <div>
                  <br />
                </div>
                <div>input: </div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"date_input_full_zulu"</span>:{" "}
                  <span className="jsonY">"2014-03-18T15:34:46.521Z"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"date_input_just_date"</span>:{" "}
                  <span className="jsonY">"2014-03-18Z"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"date_input_date_and_time"</span>:{" "}
                  <span className="jsonY">"2014-03-18T15:34Z"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">
                    "date_input_date_and_time_seconds"
                  </span>
                  : <span className="jsonY">"2014-03-18T15:34:46Z"</span>
                </div>
                <div>&#125;</div>
                <div>
                  <br />
                </div>
                <div>output: </div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"date_output_example"</span>:{" "}
                  <span className="jsonY">"2018-07-22T12:54:08.623Z"</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Object / Container</h3>
              <p>
                Objects are a way of storing a collection of base data types
                like text long and date.
              </p>
              <p>object:</p>
              <div className="darkCode">
                <div>
                  prefix: "<strong>object_</strong>"
                </div>
                <div>
                  <br />
                </div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"object_client"</span>: &#123;
                </div>
                <div className="i2">
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"long_age"</span>:{" "}
                  <span className="jsonP">35</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"date_last_contacted"</span>:{" "}
                  <span className="jsonY">"2014-03-18T15:34:46.521Z"</span>
                </div>
                <div className="i1">&#125;</div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Arrays</h3>
              <p>
                Arrays are lists of a single data type. Arrays support{" "}
                <strong>text</strong>, <strong>long</strong>,{" "}
                <strong>date</strong> and <strong>object</strong>.{" "}
              </p>
              <p>array:</p>
              <div className="darkCode">
                <div>prefix: </div>
                <div className="i1">
                  "<strong>array_text_</strong>"
                </div>
                <div className="i1">
                  "<strong>array_long_</strong>"
                </div>
                <div className="i1">
                  "<strong>array_date_</strong>"
                </div>
                <div className="i1">
                  "<strong>array_object_</strong>"
                </div>
                <div>
                  <br />
                </div>
                <div>&#123;</div>
                <div className="i1">
                  <span className="jsonG">"array_text_names"</span>: [
                  <span className="jsonY">"John"</span>,{" "}
                  <span className="jsonY">"Matthew"</span>,{" "}
                  <span className="jsonY">"Luke"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"array_long_weights"</span>: [
                  <span className="jsonP">76</span>,{" "}
                  <span className="jsonP">64</span>,{" "}
                  <span className="jsonP">79</span>,{" "}
                  <span className="jsonP">62</span>,{" "}
                  <span className="jsonP">84</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"array_date_road_trip_dates"</span>: [
                  <span className="jsonY">"2017-05-10T10:00:00.000Z"</span>,{" "}
                  <span className="jsonY">"2017-05-14T10:00:00.000Z"</span>,{" "}
                  <span className="jsonY">"2017-05-19T10:00:00.000Z"</span>,{" "}
                  <span className="jsonY">"2017-05-22T12:00:00.000Z"</span>],
                </div>
                <div className="i1">
                  <span className="jsonG">"array_object_people"</span>: [&#123;{" "}
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"John"</span>,{" "}
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span> &#125;, &#123;{" "}
                  <span className="jsonG">"text_first_name"</span>:{" "}
                  <span className="jsonY">"Sally"</span>,{" "}
                  <span className="jsonG">"text_last_name"</span>:{" "}
                  <span className="jsonY">"Smith"</span> &#125;]
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Database_naming;



// WEBPACK FOOTER //
// ./src/components/knowlege/overview/Database_naming.js